<template>
  <PdfViewer
    :input-file-id="inputFileId"
    :pdf-url="pdfUrl"
    :current-page="currentPage"
    :highlight-block-ids="highlightBlockIds"
    :highlight-block-scores="highlightBlockScores"
    :is-show-extracted-words="isShowExtractedWords"
    :is-force-show-highlight-blocks="isForceShowHighlightBlocks"
    :initial-center-ratio="initialCenterRatio"
    :initial-scale="initialScale"
    :detail-page-url="detailPageUrl"
  />
</template>

<script setup>
import { ref, shallowRef, watch, onMounted, onBeforeUnmount } from "vue"

import PdfViewer from "../../components/pdf-viewer/PdfViewer.vue"

const { element } = defineProps(["element"])

const inputFileId = ref(undefined)
const pdfUrl = ref(undefined)
const currentPage = ref(undefined)
const highlightBlockIds = shallowRef(undefined)
const highlightBlockScores = shallowRef(undefined)
const isShowExtractedWords = ref(undefined)
const isForceShowHighlightBlocks = ref(undefined)
const initialCenterRatio = ref(undefined)
const initialScale = ref(undefined)
const detailPageUrl = ref(undefined)

const observer = new MutationObserver(records => {
  for (const record of records) {
    const { target } = record
    if (target !== element) continue

    if (target.dataset.inputFileId) {
      inputFileId.value = target.dataset.inputFileId
    } else {
      inputFileId.value = undefined
    }

    if (target.dataset.pdfUrl) {
      pdfUrl.value = target.dataset.pdfUrl
    } else {
      pdfUrl.value = undefined
    }

    if (target.dataset.currentPage) {
      currentPage.value = parseInt(target.dataset.currentPage)
    } else {
      currentPage.value = 1
    }

    if (target.dataset.highlightBlockIds) {
      highlightBlockIds.value = JSON.parse(target.dataset.highlightBlockIds)
    } else {
      highlightBlockIds.value = []
    }

    if (target.dataset.highlightBlockScores) {
      highlightBlockScores.value = JSON.parse(target.dataset.highlightBlockScores)
    } else {
      highlightBlockScores.value = []
    }

    if (target.dataset.isShowExtractedWords) {
      isShowExtractedWords.value = target.dataset.isShowExtractedWords === "true"
    } else {
      isShowExtractedWords.value = false
    }

    if (target.dataset.isForceShowHighlightBlocks) {
      isForceShowHighlightBlocks.value = target.dataset.isForceShowHighlightBlocks === "true"
    } else {
      isForceShowHighlightBlocks.value = false
    }

    if (target.dataset.centerRatioTop && target.dataset.centerRatioLeft) {
      initialCenterRatio.value = {
        top: parseFloat(target.dataset.centerRatioTop),
        left: parseFloat(target.dataset.centerRatioLeft)
      }
    } else {
      initialCenterRatio.value = undefined
    }

    if (target.dataset.initialScale) {
      initialScale.value = parseFloat(target.dataset.initialScale)
    } else {
      initialScale.value = undefined
    }

    if (target.dataset.detailPageUrl) {
      detailPageUrl.value = target.dataset.detailPageUrl
    } else {
      detailPageUrl.value = undefined
    }
  }
})

watch(isShowExtractedWords, value => {
  const event = new Event("isShowExtractedWordsChanged")
  event.value = { isShowExtractedWords: value }
  element.dispatchEvent(event)
})

onMounted(() => {
  observer.observe(element, { attributes: true })
})

onBeforeUnmount(() => {
  observer.disconnect()
})
</script>
